import React, { useState } from "react";
import { classIf, getBetDescription, groupScorers } from "../data/utils";
import OddWithDesc from './OddWithDesc';
import Img from "./Img";
import BetWrapper from "./BetWrapper";
import BetOddsWrapper from "./BetOddsWrapper";
import OddSelector from "./OddSelector";
import { xs_isMobile } from "..";

export function getGroupBetDescription(bet) {
    let desc = null;
    if (bet.handicap != null) {
        if (bet.descNoHandicap) {
            desc = bet.descNoHandicap;
        } else {
            desc = bet.desc;
        }

        if (desc.includes('@@')) {
            desc = desc.replaceAll('@@H1@@', 'X')
               .replaceAll('@@H2@@', 'Y')
               .replaceAll('@@H3@@', 'Z')
               .replaceAll('@@H4@@', 'K');
        }
        if (desc.includes('{{')) {
            desc = desc.replaceAll('{{H1}}', 'X')
                    .replaceAll('{{H2}}', 'Y')
                    .replaceAll('{{H3}}', 'Z')
                    .replaceAll('{{H4}}', 'K');
        }

        return desc;
    }

    return getBetDescription(bet, true);
}

function Scorers(props) {
    const [toggled, setToggled] = useState(false);  // TODO handle live case
    const [index, setIndex] = useState(0);  // TODO handle live case

    const scorers = props.scorers;
    const selected = scorers[index];
    const team = props.team;

    return (
        <div className="c_57" onClick={() => setToggled(!toggled)}>
            <div className="c_57_1">{team}</div>
            <div className="c_57_2">
                <div className="c_57_2_1">{selected.name}</div>
                <Img className="c_57_2_2" src="icon_chevron.svg" height="16px" width="16px" data-rotate={toggled ? '180' : ''} />
            </div>
            {toggled &&
                <div className="c_57_3">
                    {scorers.map((s, i) => {
                        const desc = s.name;
                        return (
                            <div key={s.uniqueId} className={"c_57_3_1" + classIf(index === i, 'active')} onClick={() => setIndex(i)}>
                                <div className="c_57_3_1_1">{desc}</div>
                                <div className="c_57_3_1_2"></div>
                            </div>
                        );
                    })}
                </div>
            }
            {selected.bets.map(b => {
                if (b.odds.length > 4) {
                    return (
                        <BetOddsWrapper key={b.uniqueId}>
                            <OddSelector odds={b.odds} />
                        </BetOddsWrapper>
                    );
                } else {
                    return b.odds.map(o => {
                        // const desc = parseHandicap(o.desc, b.handicap, b.tipoHandicap, b.eqs, null);
                        const desc = null;
                        return <OddWithDesc key={o.uniqueId} data={o} desc={desc} />;
                    })
                }
            })}
        </div>
    );
}

export default function ScorerMarket(props) {
    let bets = props.bets;
    const firstBet = bets[0];

    const scorersByTeam = groupScorers(bets, props.team1, props.team2);

    return (
        <BetWrapper data={firstBet} desc={getGroupBetDescription(firstBet)} toggled={props.toggled}>
            {/* <div>{getGroupBetDescription(bets[0])}</div> */}
            {/* <ScorerHeader {...team1Part1[0].bets[0]} /> */}
            <BetOddsWrapper columnLayout={xs_isMobile}>
                {scorersByTeam.map(team =>
                    <Scorers key={team} scorers={team.scorers} team={team.desc} />
                )}
            </BetOddsWrapper>
        </BetWrapper>
    );
}
